// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-715ef7d4","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./client/App.vue
// module id = 1233
// module chunks = 0